// extracted by mini-css-extract-plugin
export default {"requiredAsterisk":"c2roUw0IhYhv3DZaNInt"};